var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "default-item" },
      _vm._l(_vm.prospectsFromBrokers, function (prospect) {
        return _c(
          "div",
          {
            key: prospect._id,
            staticClass:
              "card-item shadowless has-text-centered default-item-info med-size-text my-3",
          },
          [
            _c("span", { staticClass: "default-item-name content-title" }, [
              _vm._v(
                " " +
                  _vm._s(prospect.name) +
                  " " +
                  _vm._s(prospect.lastName) +
                  " "
              ),
            ]),
            _c(
              "b-tooltip",
              { attrs: { label: _vm.$t("idNumber"), position: "is-left" } },
              [
                _c("span", { staticClass: "default-item-idnumber" }, [
                  _c("i", {
                    staticClass: "fa-solid fa-address-card has-text-primary",
                  }),
                  _vm._v(
                    " " +
                      _vm._s(
                        prospect.idNumber || _vm.$t("not-avaliable-data")
                      ) +
                      " "
                  ),
                ]),
              ]
            ),
            _c(
              "b-tooltip",
              {
                staticClass: "mobile-hidden",
                attrs: {
                  label: _vm.$t("lastInteractionDate"),
                  position: "is-left",
                },
              },
              [
                prospect.lastInteractionDate
                  ? _c("span", { staticClass: "default-item-date" }, [
                      _c("i", {
                        staticClass: "fas fa-history has-text-primary",
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatDate(
                              prospect.lastInteractionDate,
                              "DD/MM/YY HH:mm"
                            )
                          ) +
                          " "
                      ),
                    ])
                  : !prospect.lastInteractionDate && prospect.createdAt
                  ? _c("span", { staticClass: "default-item-date" }, [
                      _c("i", {
                        staticClass: "fas fa-history has-text-primary",
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatDate(prospect.createdAt, "DD/MM/YY HH:mm")
                          ) +
                          " "
                      ),
                    ])
                  : _c("span", { staticClass: "default-item-date" }, [
                      _c("i", {
                        staticClass: "fas fa-history has-text-primary",
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("not-avaliable-data")) + " "),
                    ]),
              ]
            ),
            _c(
              "b-tooltip",
              {
                staticClass: "interaction-tooltip",
                attrs: {
                  label: _vm.$t("lastInteractionDate"),
                  position: "is-bottom",
                },
              },
              [
                prospect.lastInteractionDate
                  ? _c("span", { staticClass: "default-item-date" }, [
                      _c("i", {
                        staticClass: "fas fa-history has-text-primary",
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatDate(
                              prospect.lastInteractionDate,
                              "DD/MM/YY HH:mm"
                            )
                          ) +
                          " "
                      ),
                    ])
                  : !prospect.lastInteractionDate && prospect.createdAt
                  ? _c("span", { staticClass: "default-item-date" }, [
                      _c("i", {
                        staticClass: "fas fa-history has-text-primary",
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatDate(prospect.createdAt, "DD/MM/YY HH:mm")
                          ) +
                          " "
                      ),
                    ])
                  : _c("span", { staticClass: "default-item-date" }, [
                      _c("i", {
                        staticClass: "fas fa-history has-text-primary",
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("not-avaliable-data")) + " "),
                    ]),
              ]
            ),
            _c("span", { staticClass: "default-item-stage" }, [
              _vm._v(
                " " +
                  _vm._s(
                    prospect.status
                      ? _vm.$t(`prospectStatus.${prospect.status}`)
                      : "Status"
                  ) +
                  " "
              ),
              _c("br"),
              _vm._v(
                " " +
                  _vm._s(
                    prospect.subStatus
                      ? _vm.$t(`prospectSubStatus.${prospect.subStatus}`)
                      : _vm.$t("not-avaliable-data")
                  ) +
                  " "
              ),
            ]),
            _c(
              "button",
              {
                staticClass:
                  "button manage-button is-button-secondary is-rounded is-fullwidth-mobile",
                attrs: { id: `prospect-${prospect._id}` },
                on: {
                  click: function ($event) {
                    return _vm.goToSingleProspectView(prospect._id)
                  },
                },
              },
              [_vm._v(" Ver ")]
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }